import { render, staticRenderFns } from "./DateResources.vue?vue&type=template&id=41b188fd&scoped=true&lang=pug"
import script from "./DateResources.vue?vue&type=script&lang=js"
export * from "./DateResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b188fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b188fd')) {
      api.createRecord('41b188fd', component.options)
    } else {
      api.reload('41b188fd', component.options)
    }
    module.hot.accept("./DateResources.vue?vue&type=template&id=41b188fd&scoped=true&lang=pug", function () {
      api.rerender('41b188fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/dashboard/DateResources.vue"
export default component.exports